import React, { Component } from 'react'
import "./policyMatchingList.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiFastEval , getApiCompanyName } from "../../axios/api"
import { Pagination } from 'antd';
import 'antd/dist/antd.css';
import { get } from '../../axios/localstorage'
import Item from 'antd/lib/list/Item'


export default class policyMatchingList extends Component {


    state = {
        banner:[],
        list:[],

        currentIndex:0,
        nIndex:0,

        newsType:1,

        page:1,
        total:1,

        key:"",

        showMore:false,
    }

    componentWillMount(){
        window.scroll(0,0);

        let name = get('key');

        this.getList(name);
    }

    componentDidMount(){
        // getApiBanner({type:2})
        // .then( req =>{
        //     if(req.data.code === 1){
        //         this.setState({
        //             banner:req.data.data
        //         })
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        // this.getList();
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    changePage=(page)=>{
        this.setState({
            page
        })

        setTimeout(()=>{
            this.getList()
        },50)
    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }



    getList=(name)=>{
        let param = {
            searchKey:name,
            page:this.state.page,
        }

        getApiCompanyName(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                // this.setState({
                //     list:data
                // })
                // this.setState({
                //     list:data.list,
                //     total:data.total
                // })
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiFastEval({'name':name})
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    list:data.list,
                    total:data.count
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    render() {
        return (
            <div className='policyMatchingList'>
                <Header type={2} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p className='i_point' onClick={()=>{this.gotoPage('/policyMatching')}}>政策匹配</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>匹配列表</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className='hnum'>
                    <div className='cen'>
                        <div className='hmain'>
                            <button className='btn1'>下载报告</button>
                            <button className='btn2'>重新匹配</button>
                            <div className='htext'>
                                <h4>共匹配到<span>175</span>条政策</h4>
                                <p>初步估计可获得资金<span>915.45万</span>（五星），预计通过提升相关条件还可获得<span>3479.73万</span>（四星以下）</p>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className='hpage' hidden>
                    <div className='cen'>
                        <div className='hmain'>
                            <table>
                                <thead>
                                    <tr className='trh'>
                                        <th className='tfd'>公司全称</th>
                                        <th>社会统一信用代码</th>
                                        <th>公司法人</th>
                                        <th>公司成立时间</th>
                                    </tr>
                                    <tr className='trh2'>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    {
                                        this.state.list.map((item,index)=>{
                                            return <tr key={index}>
                                                        <td className='tfd'>{item.name}</td>
                                                        <td>{item.creditCode}</td>
                                                        <td>{item.legalPersonName}</td>
                                                        <td>{item.estiblishTime}</td>
                                                        {/* <td className='tstar'>
                                                            <div className='tflex'>
                                                                <img className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img className='star' alt='' src="/www/assets/imgs/star.png" />
                                                            </div>
                                                        </td>
                                                        <td className='tdw'>
                                                            <div className='tflex'>
                                                                <div className='tbtn'>0天</div>
                                                            </div>
                                                        </td> */}
                                                    </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                            {/* <div className='r_page'>
                                <Pagination type="success" showSizeChanger={false} pageSize={10}  defaultCurrent={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className='hnum'>
                    <div className='cen'>
                        <div className='hmain'>
                            {/* <div className='htype'>
                                <div className='ht1 chosen'>全部</div>
                                <div className='ht2'>最近7天内截止</div>
                                <div className='ht3'>最近30天内截止</div>
                            </div> */}

                            <h4>共查找到<span>{this.state.total}</span>条信息</h4>
                        </div>
                    </div>
                </div>

                <div className='hpage'>
                    <div className='cen'>
                        <div className='hmain'>
                            <table>
                                <thead>
                                    <tr className='trh'>
                                        <th className='tfd'>项目名称</th>
                                        <th>项目来源</th>
                                        <th>星极</th>
                                        <th>申报时间</th>
                                        {/* <th>结束倒计时</th> */}
                                    </tr>
                                    <tr className='trh2'>
                                        <th></th>
                                        <th></th>
                                        {/* <th></th> */}
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    {
                                        this.state.list.map((item,index)=>{
                                            return <tr key={index} onClick={()=>{this.gotoPage('/policySearchInfo?id='+item.id)}}>
                                                        <td className='tfd'>{item.title}</td>
                                                        <td>{item.dept}</td>
                                                        <td className='tstar'>
                                                            <div className='tflex'>
                                                                <img hidden={item.levelStar.length < 1} className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img hidden={item.levelStar.length < 2} className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img hidden={item.levelStar.length < 3} className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img hidden={item.levelStar.length < 4} className='star' alt='' src="/www/assets/imgs/star.png" />
                                                                <img hidden={item.levelStar.length < 5 } className='star' alt='' src="/www/assets/imgs/star.png" />
                                                            </div>
                                                        </td>
                                                        <td>{item.time}</td>
                                                        {/* <td className='tdw'>
                                                            <div className='tflex'>
                                                                <div className='tbtn'>0天</div>
                                                            </div>
                                                        </td> */}
                                                    </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                            {/* <div className='r_page'>
                                <Pagination type="success" showSizeChanger={false} pageSize={10}  current={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                            </div> */}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
